import React from 'react';
import { Camera, Receipt, FolderSearch } from 'lucide-react';

const CARDS = [
  {
    icon: Camera,
    title: 'The end-of-transaction scramble',
    body:
      "Closing day arrives and there are 80 files spread across Desktop, Downloads, and three Outlook attachments folders: MLS photos, signed disclosures, the ALTA, the seller net sheet, inspection PDFs. You spend an evening dragging them into the right property folder so the buyer's agent stops calling.",
  },
  {
    icon: Receipt,
    title: 'Finding last year\'s settlement at tax time',
    body:
      "Your CPA asks for the settlement statement from the Cornell Terrace closing. You know it's somewhere on the iMac. Two hours later, after searching Downloads, scanned email attachments, and three OneDrive folders, you find it. Tax archive folders should be obvious. They never are.",
  },
  {
    icon: FolderSearch,
    title: 'Personal photos mixed with listings',
    body:
      "Photos from your kid's birthday end up next to drone shots of a $750k listing because both came off the iPhone the same week. The MLS upload happens in a rush and a personal photo almost makes it into the listing. Once is funny. Twice is a problem.",
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The Filing Problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Three patterns we hear from solo agents working out of OneDrive and Desktop folders.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div
              key={i}
              className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6"
            >
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
